export default "__VITE_ASSET__DOOOGzlK__"